import React,{useState,useEffect, useRef} from 'react'
import { useParams } from 'react-router-dom';
import chatbotServices from '../chatbotServices';
import { Attachment, Phone, Send } from '@mui/icons-material';
import ConversationView from '../components/ConversationView';
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import ChatAudioInput from '../components/ChatAudioInput';
import ChatLocationInput from '../components/ChatLocationInput';
import ChatImageInput from '../components/ChatImageInput';
import AvtarSpeach from '../components/AvtarSpeach';
import AppSelect from '../../../components/AppInput/AppSelect';

function ChatPage2() {
    const messagesEndRef = useRef(null);
    const [messageInput,setMessageInput] = useState("");
    const [conversationList,setConversationList] = useState([]);
    const [loading,setLoadingStatus] = useState(false);

    const [phoneNoInput,setPhoneNoInput] = useState("");
    const [chatUserPhone,setChatUserPhone] = useState(JSON.parse(sessionStorage.getItem("chatUserPhone"))); 
    const [dialogStatus, setDialogStatus] = useState(false);
    const [nextPayload,setNextPayload] = useState(null);
	const [speachMessage,setSpeachMessage] = useState("")

	const [voiceList,setVoiceList]      = useState(null)
	const [voiceIndex,setVoiceIndex]    = useState(null);
	const [selectedVoice,setSelectedVoice] = useState(null)

	const getVoiseList = async () =>{
			
			let _voices = speechSynthesis.getVoices();
			let _voiceList = [];
			console.log()
			_voices.forEach((voice,i)=>{
				_voiceList.push({value:i,label:voice.voiceURI+" - "+voice.lang})
			})
			console.log(_voiceList);
			setVoiceList(_voiceList);
		
			if(voiceIndex == null){
				setVoiceIndex(sessionStorage.getItem('voiceIndex'));
			}
		
	}

	useEffect(()=>{
		if(voiceList === null || voiceList.length ==0){
			getVoiseList();
		}
	},[voiceList])

	useEffect(()=>{
		getVoiseList()
	},[])

	useEffect(()=>{
        if(selectedVoice !== null){
            sessionStorage.setItem('voiceIndex',selectedVoice.value)
            setVoiceIndex(selectedVoice.value)
        }
    },[selectedVoice])


	

    const updateConversation = (message,type,dataType="text") =>{
		let _message = {
			msg : message,
			type : type,
			dataType:dataType,
		}
		//let _conversationList = [...conversationList,_message]; // bug when use this method two time in one function
		if(type=="i"){
			setSpeachMessage(message);
		}
		setConversationList(_conversationList=>[..._conversationList,_message])		
		setMessageInput("");
	}


    const handleResponse = (res) =>{
		setTimeout(()=>{
			if(res.data !==null){
                console.log(res.data);
                if(res.data.messageType === "askPhoneNo"){
                    setNextPayload(res.postData);
                    setDialogStatus(true);
                } else {
                    updateConversation(res.data,"i")
                }
			}
			setLoadingStatus(false)
		},[1000])
	}

    const sendTextMessage = () =>{
		let payload = {
			messageType : "text",
			message:messageInput,
			from:chatUserPhone,
			//chatUserInfo:chatUserInfo
		}
		setLoadingStatus(true);
		updateConversation(messageInput,"o")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

	const sendSpeechRecognitionMessage = (message) =>{
		let payload = {
			messageType : "text",
			message:message,
			from:chatUserPhone,
			//chatUserInfo:chatUserInfo
		}
		setLoadingStatus(true);
		updateConversation(message,"o")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

    const sendInterectiveMessage = (option,messageType) =>{
		let payload = {
			messageType : messageType,
			id:option.optionId,
			from:chatUserPhone,
			//chatUserInfo:chatUserInfo
		}
		setLoadingStatus(true);
		console.log(option)
		updateConversation(option.optionTitle,"o")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

    const sendImageMessage = (url) =>{
		let payload = {
			messageType : "imageRequest",
			url:url,
			from:chatUserPhone,
		}
		setLoadingStatus(true);
		updateConversation(url,"o","image")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

	const sendAudioMessage = (url) =>{
		let payload = {
			messageType : "audioRequest",
			url:url,
			from:chatUserPhone,
		}
		setLoadingStatus(true);
		updateConversation(url,"o","audio")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

	const sendLocationMessage = (location) =>{
		let payload = {
			messageType : "locationRequest",
			location:location,
			from:chatUserPhone,
		}
		setLoadingStatus(true);
		updateConversation(location,"o","location")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

    const handlePhoneNoChange = () =>{
        sessionStorage.setItem("chatUserPhone",phoneNoInput);
        setChatUserPhone(phoneNoInput);
        setLoadingStatus(true);
        let payload = {...nextPayload};
        payload.from = phoneNoInput;
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
            setNextPayload(null);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{
            setLoadingStatus(false);	
            setDialogStatus(false);	
		})
    }

	const initiateConversation = () =>{
		let payload = {
			messageType : "text",
			message:"hi",
			from:chatUserPhone,
			//chatUserInfo:chatUserInfo
		}
		setLoadingStatus(true);
		//updateConversation("hi","o")
		chatbotServices.submitMessage(payload).then(res=>{
			handleResponse(res);
		}).catch(error=>{
			console.log(error);
			setLoadingStatus(false)
		}).finally(()=>{			
		})
	}

    useEffect(()=>{
		if(conversationList.length === 0){
			initiateConversation();
		}
		messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
	},[conversationList])

    return (
        <div className='container p-0'>

			{voiceIndex === null &&
                <div className='row mt-3 p-5'>
                    <div className='col-md-6 offset-md-3'>
                        <h3>Selecte a Language</h3>
                    </div>
                    <div className='col-md-6 offset-md-3'>
                        {voiceList &&
                            <AppSelect
                                options={voiceList}
                                value={selectedVoice}
                                setValue={setSelectedVoice}
                                label="Select Language" 
                                optionLabel = "label"
                            />
                        }
                    </div>
                </div>
            }

			{voiceIndex !== null &&
				<div className='row'>
					<div className='col-md-6'>
						<AvtarSpeach speachMessage={speachMessage} setSpeachMessage={setSpeachMessage} voiceIndex={voiceIndex} sendSpeechRecognitionMessage={sendSpeechRecognitionMessage} />
					</div>
					<div className='col-md-6'>
						<div className='card p-0 mt-5'>
							<div className='card-header bg-primary text-white'>G-Help</div>
							<div className='card-body' style={{height:"500px", overflowY:"scroll"}}>
								<ConversationView conversationList={conversationList} sendInterectiveMessage={sendInterectiveMessage} />
								{loading && <div className='p-3'><CircularProgress /></div> }
								<div ref={messagesEndRef} />
							</div>
							<div className='card-footer bg-white p-0 border-0'>
								<div className="input-group">
									{chatUserPhone !== null &&
									<button type="button" className="btn btn-outline-primary dropdown-toggle" data-bs-toggle="dropdown">
										<Attachment />
									</button>
									}

									<ul className="dropdown-menu">
										<li><ChatImageInput callBack={sendImageMessage} chatUserPhone={chatUserPhone} /></li>
										<li><ChatLocationInput callBack={sendLocationMessage} /></li>
									</ul>
									
									<input type="text" className="form-control bg-light" placeholder="Message"
										value={messageInput}
										onChange={(e)=>setMessageInput(e.target.value)}
										onKeyUp={ (e) =>{
											if(e.key === 'Enter') {
												e.preventDefault();
												sendTextMessage()
											}
										}}
									/>
									{chatUserPhone !== null && <ChatAudioInput callBack={sendAudioMessage} chatUserPhone={chatUserPhone}  /> }
									<button className="btn btn-outline-secondary text-success" type="button" id="button-addon3" onClick={sendTextMessage}><Send /></button>
								</div>
							</div>
						</div>
					</div>
				</div>
			}

            <Dialog
				open={dialogStatus}
				keepMounted
				onClose={()=>setDialogStatus(false)}
				maxWidth="sm"
				fullWidth={true}
			>
                <DialogTitle>Your Phone No to Continue.</DialogTitle>
                <DialogContent>
                    <div className='row mt-3'>
                        <div className='col-md-12'>
                            <div className="input-group mb-3">
                                <span className="input-group-text"><Phone/></span>
                                <input type="number" className="form-control" placeholder="Your Phone Number" 
                                    value={phoneNoInput}
                                    onChange={(e)=>setPhoneNoInput(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <button onClick={()=>setDialogStatus(false)} className='btn btn-outline-primary'>Cancel</button>
                    <button disabled={phoneNoInput.length < 10} onClick={handlePhoneNoChange} className='btn btn-primary'>Continue</button>
                </DialogActions>
            </Dialog>
        </div>
        
    )
}

export default ChatPage2